import React, { useEffect, useState } from 'react';
import api from './api';

/* Inject marquee keyframes once */
const SVC_STYLE_ID = 'svc-marquee-style';
if (!document.getElementById(SVC_STYLE_ID)) {
  const s = document.createElement('style');
  s.id = SVC_STYLE_ID;
  s.textContent = `
    @keyframes svcMarquee {
      0%   { transform: translateX(0); }
      100% { transform: translateX(-50%); }
    }
    .svc-marquee-track {
      display: flex;
      width: max-content;
      animation: svcMarquee 28s linear infinite;
    }
    .svc-marquee-track:hover {
      animation-play-state: paused;
    }
  `;
  document.head.appendChild(s);
}

const ServiceCard = ({ service }) => {
  const [hov, setHov] = useState(false);
  return (
    <div
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        width: 300, flexShrink: 0, margin: '0 10px',
        background: '#fff',
        border: hov ? '1.5px solid rgba(232,97,26,0.35)' : '1.5px solid rgba(0,0,0,0.07)',
        borderRadius: 18,
        display: 'flex', flexDirection: 'column',
        overflow: 'hidden',
        boxShadow: hov ? '0 14px 36px rgba(0,0,0,0.11)' : '0 3px 12px rgba(0,0,0,0.06)',
        transition: 'transform .25s, box-shadow .25s, border-color .25s',
        transform: hov ? 'translateY(-5px)' : 'none',
      }}
    >
      <div style={{ height: 165, overflow: 'hidden', flexShrink: 0 }}>
        <img src={service.image} alt={service.titre}
          style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform .35s', transform: hov ? 'scale(1.06)' : 'scale(1)' }}
        />
      </div>
      <div style={{ padding: '18px 20px', display: 'flex', flexDirection: 'column', flex: 1, fontFamily: "'DM Sans',sans-serif" }}>
        <h3 style={{ fontSize: '0.95rem', fontWeight: 700, color: '#1e293b', margin: '0 0 7px', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
          {service.titre}
        </h3>
        <p style={{ fontSize: '0.82rem', color: '#64748b', lineHeight: 1.6, margin: 0, display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden', flex: 1 }}>
          {service.description}
        </p>
        <a href={service.link} style={{ marginTop: 14, display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: '0.8rem', fontWeight: 700, color: '#E8611A', textDecoration: 'none' }}>
          En savoir plus
          <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
        </a>
      </div>
    </div>
  );
};

const ServicesSection = () => {
 const [services, setServices] = useState([]);
 const [loading, setLoading] = useState(true);

 useEffect(() => {
   api.get('/aydees/liste-service/')
     .then(res => setServices(res.data))
     .catch(err => console.error('Erreur:', err))
     .finally(() => setLoading(false));
 }, []);

 if (loading) {
   return (
     <div style={{ padding: '80px 0', background: 'linear-gradient(160deg,#0b1120 0%,#0f172a 50%,#111827 100%)', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 400 }}>
       <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-orange-500"></div>
     </div>
   );
 }

 if (!services || services.length === 0) return null;

 return (
   <section style={{
     background: 'linear-gradient(135deg,#fff7ed 0%,#ffffff 50%,#f8fafc 100%)',
     padding: '52px 0 48px', position: 'relative', overflow: 'hidden',
     fontFamily: "'DM Sans', sans-serif",
   }}>
     <div style={{ position:'absolute', inset:0, opacity:0.4, pointerEvents:'none', backgroundImage:'radial-gradient(circle,#e2e8f0 1px,transparent 1px)', backgroundSize:'28px 28px' }} />
     <div style={{ position:'absolute', top:'-10%', right:'10%', width:300, height:300, borderRadius:'50%', background:'radial-gradient(circle,rgba(232,97,26,0.15) 0%,transparent 70%)', filter:'blur(50px)', pointerEvents:'none' }} />
     <div style={{ position:'absolute', bottom:'-10%', left:'5%', width:260, height:260, borderRadius:'50%', background:'radial-gradient(circle,rgba(59,130,246,0.10) 0%,transparent 70%)', filter:'blur(50px)', pointerEvents:'none' }} />

     <div style={{ maxWidth:1200, margin:'0 auto', padding:'0 24px', position:'relative', zIndex:1 }}>
       <div style={{ textAlign:'center', marginBottom:36 }}>
         <div style={{ display:'inline-flex', alignItems:'center', gap:8, padding:'6px 18px', borderRadius:999, border:'1px solid rgba(232,97,26,0.3)', background:'rgba(232,97,26,0.08)', marginBottom:14 }}>
           <svg width="11" height="11" viewBox="0 0 24 24" fill="#E8611A"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
           <span style={{ fontSize:'0.68rem', fontWeight:700, color:'#E8611A', letterSpacing:'0.1em', textTransform:'uppercase' }}>Notre force, la synergie de nos expertises</span>
         </div>
         <h2 style={{ fontSize:'clamp(1.5rem,3vw,2rem)', fontWeight:800, color:'#1e293b', margin:'0 0 10px' }}>Nos services</h2>
         <div style={{ width:36, height:2, background:'linear-gradient(90deg,#E8611A,#16a34a)', borderRadius:4, margin:'0 auto' }} />
       </div>

       <div style={{ position:'relative', overflow:'hidden' }}>
         <div style={{ position:'absolute', left:0, top:0, width:80, height:'100%', background:'linear-gradient(to right,#fff7ed,transparent)', zIndex:10, pointerEvents:'none' }} />
         <div style={{ position:'absolute', right:0, top:0, width:80, height:'100%', background:'linear-gradient(to left,#f8fafc,transparent)', zIndex:10, pointerEvents:'none' }} />
         <div className="svc-marquee-track" style={{ padding:'12px 0' }}>
           {[...services, ...services].map((service, index) => (
             <ServiceCard key={`${service.id}-${index}`} service={service} />
           ))}
         </div>
       </div>

       <div style={{ textAlign:'center', marginTop:32 }}>
         <a href="#" style={{
           display:'inline-flex', alignItems:'center', gap:8,
           padding:'12px 28px', borderRadius:10,
           background:'#E8611A', color:'#fff',
           fontWeight:700, fontSize:'0.88rem', textDecoration:'none',
           transition:'background .2s, transform .2s',
         }}
         onMouseEnter={e => { e.currentTarget.style.background='#d4501a'; e.currentTarget.style.transform='translateY(-2px)'; }}
         onMouseLeave={e => { e.currentTarget.style.background='#E8611A'; e.currentTarget.style.transform='none'; }}
         >
           Découvrir tous nos services
           <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
         </a>
       </div>
     </div>
   </section>
 );
};

export default ServicesSection;